const PrevSlideIcon = (): JSX.Element => {
  return (
    <svg
      width='29'
      height='19'
      viewBox='0 0 29 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M1.66406 9.76882L0.956958 9.06171C0.566434 9.45223 0.56643 10.0854 0.95695 10.4759L1.66406 9.76882ZM1.66406 10.7688L28.3307 10.7689L28.3307 8.76888L1.66406 8.76882L1.66406 10.7688ZM10.7044 17.3951L2.37117 9.06171L0.95695 10.4759L9.29022 18.8093L10.7044 17.3951ZM2.37117 10.4759L10.7045 2.14266L9.29029 0.728437L0.956958 9.06171L2.37117 10.4759Z'
        fill='#003243'
      />
    </svg>
  );
};

export default PrevSlideIcon;
